<section>
  <div class="cert__filter-and-chart">
    <!-- <cert-filter-dns [prefixes]="prefixes()" (filtersChanged)="onFiltersChanged($event)"></cert-filter-dns> -->
    <cert-filter-dns [prefixes]="prefixes()" (filtersChanged)="onFiltersChanged($event)"></cert-filter-dns>
    <div></div>
    <i class="cert__filter-divider">
      <span></span>
      <span></span>
      <span></span>
    </i>
    <cert-chart-generic
      [series]="dnsFirewallChartSeries()"
      [legendGroups]="dnsFirewallChartLegendGroups()"
      [loading]="loadingState()"
      legendTitle="RPZ feed"
    ></cert-chart-generic>
  </div>
  <cert-dns-firewall-table
    [dnsFirewallLogs]="dnsFirewallLogs()"
    [pageInfo]="pageInfo()"
    (paginationChanged)="onPaginationChanged($event)"
    (sortingChanged)="onSortingChanged($event)"
    (pageSizeChanged)="onPageSizeChanged($event)"
  ></cert-dns-firewall-table>
</section>
